import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { Grid, GridItem, useToast, Flex } from '@chakra-ui/react'
import {
  UploadFile,
  CustomToast,
  BarFileName,
  Button,
  InputComtrol,
  Select2
} from '../UI'
import { uploadSchema } from './Schema'
import { useMutateProgram } from '../../hooks/ProgramsSync'
import { GetFormData, Files, GetNotification, ProgramsList } from '../../Utils'
import DownloadTemplate from './DownloadTemplate'
import InfoColumnTemplate from './InfoColumnTemplate'
// import DownloadTemplateFile from './DownloadTemplateFile'

const FormUpload = ({ refetch }) => {
  const toast = useToast()
  const { mutate, isLoading, reset } = useMutateProgram('UPLOAD-MASIVE')

  const filteredProgramsList = () => {
    const newProgramsList = [
      { key: '', name: '' },
      ...ProgramsList.filter((item) => item.key !== 'DisasterSupport')
    ]
    return newProgramsList
  }

  const initialValues = {
    program: '',
    uploadFileNames: [],
    uploadFile: null
  }

  const formik = useFormik({
    initialValues,
    validationSchema: uploadSchema,
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
    onSubmit: (values) => {
      const formData = GetFormData(values, ['uploadFile'], ['uploadFileNames'])

      const test = true
      if (test) {
        mutate(formData, {
          onSuccess: (response) => {
            refetch()
            reset()
            formik.resetForm()
            GetNotification.basic(
              response?.success?.message ||
                'El archivo fue cargado, será notificado una vez el proceso haya culminado',
              'Aceptar'
            )
          },
          onError: (err) => {
            const response = JSON.parse(err.request.response)
            GetNotification.basic(
              'Error',
              'Aceptar',
              response?.error?.message || 'Error al Cargar archivo',
              'error'
            )
          }
        })
      }
    }
  })

  const deleteFile = (fileName) => {
    const { getArrayNamesAndArrayFiles } = Files

    const { resultNames, resultListFiles: resultFiles } =
      getArrayNamesAndArrayFiles(
        fileName,
        formik.values.uploadFileNames,
        formik.values.uploadFile
      )

    formik.setValues({
      ...formik.values,
      uploadFileNames: resultNames,
      uploadFile: resultFiles
    })
  }

  const handleChangeFile = (e) => {
    if (!e.currentTarget.files) {
      return
    }
    const { getListNamesAndListFiles } = Files

    const { newListNames: newFilesNames, newListFiles: newFiles } =
      getListNamesAndListFiles(e.currentTarget, [], [])

    formik.setValues({
      ...formik.values,
      uploadFileNames: newFilesNames,
      uploadFile: newFiles
    })
    e.target.value = null
  }

  useEffect(() => {
    if (formik.isSubmitting && Object.keys(formik.errors).length > 0) {
      Object.keys(formik.errors).forEach((key) => {
        toast({
          duration: 2000,
          isClosable: true,
          position: 'top-right',
          render: ({ onClose }) => (
            <CustomToast
              text={formik.errors[key]}
              showSpinner={false}
              status={'error'}
              onClose={onClose}
            />
          )
        })
      })
    }
  }, [formik.errors])

  const handleChangeProgram = (value) => {
    formik.setFieldValue('program', value)
  }

  return (
    <Grid
      templateColumns={{
        lg: 'repeat(3, 1fr)',
        md: 'repeat(3, 1fr)',
        sm: 'repeat(1, 1fr)'
      }}
      gap={10}
    >
      <GridItem>
        <InputComtrol
          isRequired={true}
          id={'program'}
          label={'Programa'}
          error={Boolean(formik.errors.program)}
          errorText={formik.errors.program}
        >
          <Select2
            bg={'white'}
            list={filteredProgramsList()}
            value={formik.values.program}
            onChange={handleChangeProgram}
          />
        </InputComtrol>
      </GridItem>
      <GridItem color={'green.500'}>
        <UploadFile
          id={'uploadFileNames'}
          p={5}
          onChange={(e) => handleChangeFile(e)}
          error={Boolean(formik.errors.uploadFileNames)}
          errorText={formik.errors.uploadFileNames}
          multiple={false}
        />
      </GridItem>
      <GridItem>
        <Flex direction={'column'} gap={1} my={2}>
          {formik?.values?.uploadFileNames?.map((item) => (
            <BarFileName
              key={item?.name}
              fileName={item?.name}
              fileUrl={item?.url}
              onDelete={() => deleteFile(item?.name)}
            />
          ))}
        </Flex>
        <Flex direction={'column'} gap={2}>
          <InfoColumnTemplate />
          <DownloadTemplate keyProgram={formik.values.program} />
          <Button
            text={'Cargar archivo'}
            px={10}
            onClick={formik.handleSubmit}
            isLoading={isLoading}
            disabled={isLoading}
          />
          {/* <DownloadTemplateFile /> */}
        </Flex>
      </GridItem>
    </Grid>
  )
}

export default FormUpload
